import AssessmentFailedImage from "../assets/assessment-failed-image"
import { finishWebView } from "../shared/app-interface"
import BottomSheet from "../shared/components/bottom-sheet"
import { NAVIGATE } from "../shared/constants/navigation-types"
import { useAssessmentStore } from "../shared/store"

interface AssessmentFailedSheetProps {
    open: boolean
}
// will be active in the second phase, no assessment failure status as of now
const AssessmentFailedSheet = ({ open }: AssessmentFailedSheetProps) => {
    const { assesmentQuestions, jobDetails } = useAssessmentStore((state) => state)
    const isVasFlow = assesmentQuestions?.mandatory
    const hrNumber = jobDetails?.job_info?.interview_detail?.hr_number
    const isEnglishAvailable = jobDetails?.job_assessment_info?.english_required
    const jobTitle = jobDetails?.job_info?.title

    const handleTryAgain = () => {
        console.log("Click")
    }
    const handleViewMorejobs = () => {
        const data = {
            intent: "navigate",
            flowType: isVasFlow ? "vas" : "enrichment",
            // add track to the type
            navigateTo: NAVIGATE.VIEW_JOB,
            jobId: "12323",
            hrNumber: hrNumber,
            isEnglishAvailable: isEnglishAvailable,
            jobTitle: jobTitle,
        }
        finishWebView(JSON.stringify(data))
    }

    return (
        <BottomSheet open={open}>
            <div className="flex flex-col items-center justify-end w-[100%] mt-[120px]">
                {/* Content */}
                <div className=" w-[100%] flex flex-col items-center justify-center p-4">
                    <div className="flex flex-col items-center my-8">
                        <AssessmentFailedImage />
                        <p className="mt-4 text-base font-semibold">Sorry</p>
                        <p className="mt text-sm font-normal">
                            You did not qualify in this round
                        </p>
                    </div>

                    {/* Button */}
                    <div className="w-[100%] mt-[116px]">
                        <button
                            onClick={handleTryAgain}
                            className="w-[100%] p-4 rounded-lg flex justify-center items-center bg-green mb-2"
                        >
                            <p className="ml-2 font-semibold text-base text-white leading-6">
                                Try Again
                            </p>
                        </button>
                        <button
                            onClick={handleViewMorejobs}
                            className="w-[100%] p-4 rounded-lg flex justify-center items-center bg-white border-solid border border-[#02C39A] "
                        >
                            <p className="ml-2 font-semibold text-base text-[#02C39A]">
                                View more jobs
                            </p>
                        </button>
                    </div>
                </div>
            </div>
        </BottomSheet>
    )
}
export default AssessmentFailedSheet
